import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { packetsServicesAction } from "src/store/Slices/Administrator/PacketsServicesSlice";
import AddEditPacketsTrainingsModal from "./Modals/AddEditPacketsServicesModal";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const PacketsServices = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);
    
    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: false//!mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: false //!mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    //for mobile
    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "packetId", title: "Пакет" },
        { label: "По тренеру", value: 2, index: "serviceId", title: "Тренер" },
        {
            label: "По месяцам длительности",
            value: 3,
            index: "monthsActive",
            title: "Месяцев длительности",
        },
        {
            label: "По числу тренировок",
            value: 4,
            index: "numberOfTrainings",
            title: "Число тренировок",
        },
        {
            label: "По покупке с",
            value: 5,
            index: "buyableFrom",
            title: "Покупаемо с",
        },
        {
            label: "По покупке до",
            value: 6,
            index: "buyableTo",
            title: "Покупаемо до",
        },
        { label: "По цене", value: 7, index: "price", title: "Цена" },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [packetsTrainingsInfo, setPacketsTrainingsInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const packetsTrainingsList = useSelector(
        (state) => state.PacketsServicesSlice.packetsServicesList
    );
    const packetsTrainingsListLoading = useSelector(
        (state) => state.PacketsServicesSlice.packetsServicesListLoading
    );
    
    const onClickDelete = () => {
        dispatch(
            packetsServicesAction({
                flag: "delete",
                value: { packetId: packetsTrainingsInfo.id },
            })
        ).then(() => {
            dispatch(packetsServicesAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "Id") {
                        formattedItems["Id.From"] = values[index][0];
                        formattedItems["Id.To"] = values[index][1];
                    } else if (key === "price") {
                        formattedItems["price.From"] = values[index][0];
                        formattedItems["price.To"] = values[index][1];
                    } else if (key === "employ") {
                        formattedItems["employId"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            packetsServicesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setPacketsTrainingsInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            packetsServicesAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            packetsServicesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(packetsServicesAction({ flag: "get" }));
    }, []);

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(
            packetsServicesAction({ flag: "get", value: { isDeleted: value } })
        );
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditPacketsTrainingsModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                packetsTrainingsInfo={packetsTrainingsInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={packetsTrainingsListLoading}
                    onClickRowOne={(record) => {
                        setPacketsTrainingsInfo(record);
                    }}
                    columns={packetsTrainingsList}
                    rows={packetsTrainingsList?.data?.value?.rows}
                    total={packetsTrainingsList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={false
                                // !mnemo?.children?.find(
                                //     (el) => el.mnemo === "insertBtn"
                                // ) 
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    items={items}
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={packetsTrainingsList}
                    elementsListLoading={packetsTrainingsListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    handlePaginationChange={handlePaginationChange}
                    clickOnAction={clickOnAction}
                    filterOptionsArr={filterOptionsArr}
                    onChange={handleTableChange}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default PacketsServices;
